import script from "./dropdown-content.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdown-content.vue?vue&type=script&setup=true&lang=js"

import "./dropdown-content.vue?vue&type=style&index=0&id=b2088172&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2088172"]])

export default __exports__